import React, { useState, useEffect, useRef } from "react";
import { HangPlusIcon } from './component/HangPlusIcon';
import { useHistory } from "react-router-dom";
import { constantConfig } from 'web-common';
import { 
	DEVELOPMENT_HISTORY_LIST, COMPANY_PROFILES, COMPANY_HONER_IMAGES, 
	ABOUTUS_STATIC_IMAGES, AboutAnchorEnum, JZFZ_IN_CHINA, LEADING_CONTENTS,
} from './config/index';
import { CHAIRMAN_BOSS, SHAREHOLDER_BOSS } from './config/shareholder';
import { getQueryParams } from '../../util/common';
import { BannerPoster } from '../common/BannerPoster';

import './style/indexMobile.less';

const { WEBSITE_PATHS } = constantConfig;

 interface AboutUsMobileProps {
	companyList: any[]; // 公司列表
}


/**
 * 企业文化红色间隔线
 */
const mobileCultureGapLine = () => (
	<div className="pr h50 flexic">
		<HangPlusIcon position={{left: 0}} />
		<div className="h1 flex1 mlr43" style={{background: '#FF1D38'}}></div>
		<HangPlusIcon  position={{right: 0}} />
	</div>
); 


/**
 * 关于我们,移动设备页面
 * @constructor
 */
export const AboutUsMobile = (props: AboutUsMobileProps) => {

	const { anchor } = getQueryParams();
	const { companyList } = props;
	const history = useHistory();
	const [activeAnchor, setActiveAnchor] = useState<AboutAnchorEnum>(null); // 激活的锚点
	const [activeYear, setActiveYear] = useState<number>(2002); // 发展历程，展开的年份
	const [honorItemIndex, setHonorItemIndex] = useState<number>(null); // 荣誉图片索引

	// 公司简介锚点
	const profileRef = useRef<any>(null);
	// 企业文化锚点
	const cultureRef = useRef<any>(null);
	// 管理团队锚点
	const teamRef = useRef<any>(null);



	useEffect(() => {
		// 锚点
		handleAnchor(anchor);
	}, [anchor]);


	useEffect(() => {
		// 监听滚动锚点事件
		const handleScroll = () => {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			let tempAnchor = null;
			if (scrollTop > 0) {
				if (scrollTop >= profileRef.current.offsetTop) {
					tempAnchor = AboutAnchorEnum.PROFILE;
				}
				if (scrollTop >= cultureRef.current.offsetTop) {
					tempAnchor = AboutAnchorEnum.CULTURE;
				}
				if (scrollTop >= teamRef.current.offsetTop) {
					tempAnchor = AboutAnchorEnum.TEAM;
				}
			}
			setActiveAnchor(tempAnchor);
		};
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);


	/**
	 * 处理锚点事件
	 * @param anchorId 
	 */
	const handleAnchor = (anchorId: AboutAnchorEnum) => {
		let currentRef = null;
		if (anchorId === AboutAnchorEnum.PROFILE) {
			currentRef = profileRef.current;
		}
		if (anchorId === AboutAnchorEnum.CULTURE) {
			currentRef = cultureRef.current;
		}
		if (anchorId === AboutAnchorEnum.TEAM) {
			currentRef = teamRef.current;
		}
		if (currentRef) {
			const offsetTop = currentRef.offsetTop;
			window.scrollTo({ 
				top: offsetTop, 
				behavior: "smooth" 
			});
			setActiveAnchor(anchorId);
		}
	};
	

	return (
		<div className="company-mobile-aboutUs-wrapper">

			{/* banner */}
			<div className="w banner ofh">
				<img src={ABOUTUS_STATIC_IMAGES.bannerMobile} loading="lazy" className="w" />
				<div className="banner-poster-wrapper">
					<BannerPoster align="tl" />
				</div>
			</div>

			{/* 黑字logo，文本介绍 */}
			<div ref={profileRef} className="mtb64 mlr16 company-profile">
                <img src={ABOUTUS_STATIC_IMAGES.logoBlack} loading="lazy" className="mb32" />
                <div className="f14 profile-detail-text">
					{
						COMPANY_PROFILES.map((v: string, vi: number) => (<p className="mb24 f15" key={vi}>{v}</p>))
					}
				</div>
            </div>

			{/* 全球和全国排行 */}
			<div className="ranking-info">
				<div className="ptb20">
					<div className="ranking-name">全球</div>
					<div className="ranking-name"><img src={require('../../assets/images/aboutUs/TOP50.png')} alt="全球排行" /></div>
					<div className="mt20 ranking-subtitle">WA100 2025</div>
					<div className="ranking-subtitle">全球建筑设计公司榜单</div>
					<div className="mt20 ranking-detail">GLOBAL TOP50 From WA100 2025</div>
					<div className="ranking-detail">Global Architectural Design Firms Ranking</div>
				</div>
				<div className="ptb20 mt20">
					<div className="ranking-name">全国民营</div>
					<div className="ranking-name"><img src={require('../../assets/images/aboutUs/TOP3.png')} alt="全国民营" /></div>
					<div className="mt20 ranking-subtitle">中国勘察设计协会</div>
					<div className="ranking-subtitle">中国十大民营工程设计企业排行榜</div>
					<div className="mt20 ranking-detail">TOP3 Nationwide From Ranking of Top 10 Private Architectural Design Enterprises in China Honored by China Survey and Design Association</div>
				</div>
				<div className="ptb20 mt20">
					<div className="ranking-name"><img src={require('../../assets/images/aboutUs/TOP9.png')} alt="全国领先" />全国领先</div>
					<div className="ranking-name">全国领先</div>
					<div className="mt20 ranking-subtitle">中国勘察设计协会</div>
					<div className="ranking-subtitle">中国十大民营工程设计企业排行榜</div>
					<div className="mt20 ranking-detail">Pioneering Expertise in 9 Sectors From Ranking of Top 10 Private Architectural Design Enterprises in China Honored by China Survey and Design Association</div>
				</div>
			</div>

			{/* 领先的xxxx */}
			<div className="leading-container">
				{
					LEADING_CONTENTS.map(v => {
						return (
							<div className="leading-item" key={v.enTitle[0]}>
								<div className="en-title">{v.enTitle.join(' ')}</div>
								<div className="cn-title">{v.title.join(' ')}</div>
								<div className="leading-detail">{v.detail}</div>
							</div>
						);
					})
				}
			</div>

			{/* 地图 */}
			<div className="mlr16 company-expansion-map">
				<div className="f32" style={{ color: '#222' }}>{JZFZ_IN_CHINA.title}</div>
				<div className="f16" style={{ color: '#FF1D38' }}>{JZFZ_IN_CHINA.enTitle}</div>
				<div className="mtb72" style={{ color: '#BBBBBB' }}>
					{companyList.map(v => `${v.contactName} ${v.englishName} | `)}
				</div>
				<div className="w tc">
					<img src={ABOUTUS_STATIC_IMAGES.jzfzInChinaMapImgURL} loading="lazy" className="w" />
				</div>
				<div className="w flexjc">
					<div className="flexjc tc mtb100">
						{JZFZ_IN_CHINA.details.map((v, vi) => {
							return (
								<div className="flex" key={vi}>
									<div className="jzfz-inchinamap-count">
										<div className="f24">{v.amount}</div>
										<div className="f12">{v.incident}</div>
									</div>
									{
										vi < JZFZ_IN_CHINA.details.length - 1 ? (
											<div className="jzfz-inchinamap-line mlr5" title="线" />
										) : (null)
									}
									
								</div>
							);
						})}
					</div>
				</div>
			</div>

			{/* 发展历程 */}
			<div className="mlr16 mobile-development-history">
                <div className="h1 pr top-line">
                    <HangPlusIcon position={{left: -44, top: -16}} />
                    <HangPlusIcon  position={{right: -44, top: -16}} />
                </div>
                <div className="mt32">
                    <div className="f32" style={{color: '#222'}}>发展历程</div>
                    <div className="f18" style={{color: '#FF1D38'}}>Development History</div>
                </div>
                <div className="mt32">
                    {
                        DEVELOPMENT_HISTORY_LIST.map((v: any, i: number) => {
                            if (activeYear === v.year) {
                                return (
                                    <div key={i} className="mobile-history-item active">
                                        <div className="f18">{v.text}</div>
                                        <div className="f80 mt36 pa" style={{bottom: '0px'}}>{v.year}</div>
                                    </div>
                                );
                            }
                            return (
                                <div 
                                    key={i}
                                    className="mobile-history-item flexic flexjc" 
                                    onClick={() => setActiveYear((y => y === v.year ? null : v.year))}
                                >
                                    {v.year}
                                </div>
                            );
                        })
                    }
                </div>
                <div className="pr h35 mtb32">
                    <HangPlusIcon position={{left: 0, bottom: 0}} />
                    <HangPlusIcon  position={{right: 0, bottom: 0}} />
                </div>
            </div>

			{/* 企业荣誉 */}
			<div className="mobile-company-honor plr16 pt80">
                <div className="f32" style={{color: '#222'}}>企业荣誉</div>
                <div className="f18" style={{color: '#FF1D38'}}>Enterprise Honors</div>
                <div className="pr h35 mtb32">
                    <HangPlusIcon position={{left: 0, bottom: 0}} />
                    <HangPlusIcon  position={{right: 0, bottom: 0}} />
                </div>
                <div className="">
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(1)}>
                        <img src={honorItemIndex === 1 ? COMPANY_HONER_IMAGES.usuallyHover1 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
                        <span className="text flexic flexjc f24">全国勘察设计行业优秀民营企业</span>
                    </div>
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(2)}>
                        <img src={honorItemIndex === 2 ? COMPANY_HONER_IMAGES.usuallyHover2 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
                        <span className="text flexic flexjc f24">四川省民营企业党建工作示范企业</span>
                    </div>
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(3)}>
                        <img src={honorItemIndex === 3 ? COMPANY_HONER_IMAGES.usuallyHover3 : COMPANY_HONER_IMAGES.usually3} loading="lazy" />
                        <span className="text flexic flexjc f24">中国十大民营工程设计企业</span>
                    </div>
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(5)}>
                        <img src={honorItemIndex === 5 ? COMPANY_HONER_IMAGES.usuallyHover5 : COMPANY_HONER_IMAGES.usually5} loading="lazy" />
                        <span className="text flexic flexjc f24">四川省优秀民营企业</span>
                    </div>
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(4)}>
                        <img src={honorItemIndex === 4 ? COMPANY_HONER_IMAGES.usuallyHover4 : COMPANY_HONER_IMAGES.usually4} loading="lazy" />
                        <span className="text flexic flexjc f24">四川省厂务公开民主管理示范单位</span>
                    </div>
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(6)}>
                        <img src={honorItemIndex === 6 ? COMPANY_HONER_IMAGES.usuallyHover6 : COMPANY_HONER_IMAGES.usually6} loading="lazy" />
                        <span className="text flexic flexjc f24">当代中国建筑设计百家名院</span>
                    </div>
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(7)}>
                        <img src={honorItemIndex === 7 ? COMPANY_HONER_IMAGES.usuallyHover7 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
                        <span className="text flexic flexjc f24">成都市百强民营企业</span>
                    </div>
                    <div className="mobile-honor-item" onClick={() => setHonorItemIndex(8)}>
                        <img src={honorItemIndex === 8 ? COMPANY_HONER_IMAGES.usuallyHover8 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
                        <span className="text flexic flexjc f24">成都市先进基层党组织</span>
                    </div>
                </div>
                <div className="pr h35 ptb32">
                    <HangPlusIcon position={{left: 0, bottom: 20}} />
                    <HangPlusIcon  position={{right: 0, bottom: 20}} />
                </div>
            </div>

			{/* 企业文化 */}
			<div ref={cultureRef} className="mobile-company-culture pt64 plr16">
                <div className="f32" style={{color: '#222'}}>企业文化</div>
                <div className="f18">Enterprise Honors</div>
                {mobileCultureGapLine()}
                <div className="ptb20 plr5 culture1">
                    <div className="f24">愿景</div>
                    <div className="f14">成为中国一流，具有世界影响力的大型工程设计咨询管理企业，促进建筑、城乡和社会的可持续发展。</div>
                </div>
                {mobileCultureGapLine()}
                <div className="ptb20 plr5 culture2">
                    <div className="f24">使命</div>
                    <div className="f14">为城乡建筑投资商提供咨询、设计、管理的全面解决方案，为城乡和建筑的可持续发展贡献心力。</div>
                </div>
                {mobileCultureGapLine()}
                <div className="ptb20 plr5 culture3">
                    <div className="f24">核心价值观</div>
                    <div className="f14">诚信守法、成就客户、持续创新、专业服务、团队合作。</div>
                </div>
                {mobileCultureGapLine()}
                <div className="ptb20 plr5 culture4">
                    <div className="f24">发展观</div>
                    <div className="f14">共同创造、共同发展、共同分享、共同成就。让员工更满意、让客户更满意、促进社会和谐可持续发展。</div>
                </div>
                {mobileCultureGapLine()}
            </div>

			{/* 管理团队 */}
			<div ref={teamRef} className="plr16 ptb30">
                <div className="f32" style={{color: '#222'}}>管理团队</div>
                <div className="f18 mb40" style={{color: '#FF1D38'}}>Management Team</div>	
                <div className="flexjs mb32">
                    <div className="flex1 p5" style={{background: '#f2f2f2'}}>
                        <div className="f24">{CHAIRMAN_BOSS.name}</div>
                        <p className="f12 ptb6">{CHAIRMAN_BOSS.contents[0]}</p>
                        <div className="h2 mb2" style={{background: '#FF1D38'}} />
                        <p className="f12 lh16">{CHAIRMAN_BOSS.contents[1]}</p>
                        <p className="f12 lh16">{CHAIRMAN_BOSS.contents[2]}</p>
                    </div>
                    <div style={{width: '38.8%'}}><img className="w" src={CHAIRMAN_BOSS.avatar} /></div>
                </div>
                {
                    SHAREHOLDER_BOSS.map(item => {
                        const { name, titles, avatar, contents } = item;
                        return (
                            <div className="flexjs mb32" key={name}>
                                <div className="flex1 p5">
                                    <div className="f24">{name}</div>
									{titles.map(text => <p key={text} className="f12 ptb6">{text}</p>)}
                                    <div className="h2 mb2" style={{background: '#F2F2F2'}} />
                                    {contents.map(v => (<p key={v} className="f12 lh16">{v}</p>))}
                                </div>
                                <div style={{width: '38.8%'}}><img className="w" src={avatar} /></div>
                            </div>
                        );
                    })
                }
            </div>

			{/* 总结 */}
			<div className="tr plr16 ptb30" style={{color: '#DDDDDD'}}>
				<BannerPoster />
			</div>

			{/* 页尾导航 */}
			<div className="flexic flexjce flexe mtb30 lh16 plr16">
				<div className="dib crp tc mr12" onClick={() => history.replace(WEBSITE_PATHS.home)}>
					<div style={{color: '#ADADAD'}}>首页</div>
					<div className="f12" style={{color: '#D4D4D4'}}>HOME</div>
				</div>
				<div className="dib w2 h28 mr12" style={{background: '#ADADAD'}} />
				<div className="dib crp tc" onClick={() => history.replace(WEBSITE_PATHS.news)}>
					<div style={{color: '#ADADAD'}}>动态</div>
					<div className="f12" style={{color: '#D4D4D4'}}>NEWS</div>
				</div>
				<div className="dib crp tc mr12" onClick={() => history.replace(WEBSITE_PATHS.product)}>
					<div style={{color: '#ADADAD'}}>作品</div>
					<div className="f12" style={{color: '#D4D4D4'}}>PROJECTS</div>
				</div>
				<div className="dib crp tc mr12" onClick={() => history.replace(WEBSITE_PATHS.news)}>
					<div style={{color: '#ADADAD'}}>奖项</div>
					<div className="f12" style={{color: '#D4D4D4'}}>AWARDS</div>
				</div>
				<div className="dib crp tc" onClick={() => history.replace(WEBSITE_PATHS.contactUs)}>
					<div style={{color: '#ADADAD'}}>联系</div>
					<div className="f12" style={{color: '#D4D4D4'}}>CONTACTS</div>
				</div>
			</div>

		</div>
	)
};
